import { DropAction, Node, NodeInfo } from '@candulabs/craft';

export const getDropActionFromNodePosition = (
  parent: Node,
  dims: NodeInfo[],
  posX: number,
  posY: number,
): DropAction => {
  const result: DropAction = {
    parent,
    index: 0,
    where: 'before',
  };

  let nodeCenterX = 0;
  let latestNodeCenterX = 0;

  let nodeCenterY = 0;
  let latestNodeCenterY = 0;

  let nodeRight = 0;
  let latestNodeRight = 0;

  let nodeBottom = 0;
  let latestNodeBottom = 0;

  // Each dim is: Top, Left, Height, Width
  dims.forEach((dim, i) => {
    // Right position of the element. Left + Width
    nodeRight = dim.left + dim.outerWidth;
    // Bottom position of the element. Top + Height
    nodeBottom = dim.top + dim.outerHeight;
    // X center position of the element. Left + (Width / 2)
    nodeCenterX = dim.left + dim.outerWidth / 2;
    // Y center position of the element. Top + (Height / 2)
    nodeCenterY = dim.top + dim.outerHeight / 2;

    // Skip if over the limits (i.e. when we find a match, stop iterating over next nodes)
    if (
      (latestNodeCenterX && nodeCenterX >= latestNodeCenterX) ||
      (latestNodeCenterY && nodeCenterY >= latestNodeCenterY) || // >= avoid issue with clearfixes
      (latestNodeRight && posX <= latestNodeRight) ||
      (latestNodeBottom && posY <= latestNodeBottom)
    ) {
      return;
    }

    result.index = i;

    if (!dim.inFlow) {
      // If it's not in flow (like flex-row child or inline-block - i.e. vertical indicator)
      if (posX < nodeCenterX) {
        // If mouse x less than center
        latestNodeCenterX = nodeCenterX;
        result.where = 'before';
      } else {
        latestNodeRight = nodeRight;
        result.where = 'after';
      }
      return;
    }

    if (dim.inFlow) {
      // If it's in flow (i.e. horizontal indicator)
      if (posY < nodeCenterY) {
        // If mouse y greater than center
        latestNodeCenterY = nodeCenterY;
        result.where = 'before';
      } else {
        latestNodeBottom = nodeBottom;
        result.where = 'after'; // After last element
      }
    }
  });

  return result;
};
